import { render, staticRenderFns } from "./AppVersionTable.vue?vue&type=template&id=14edd3bf&"
import script from "./AppVersionTable.vue?vue&type=script&lang=js&"
export * from "./AppVersionTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports